<template>
  
  <v-tooltip
    bottom
    :open-delay   = "500"
  >

    <template v-slot:activator="{ on, attrs }">
      <v-avatar
        class   = "elevation-2"
        size    = "36"
        v-bind  = "attrs"
        v-on    = "on"
        :color  = "color"
      >
        <v-icon v-if="!user">
          mdi-account-circle
        </v-icon>

        <span v-else>{{ avatar }}</span>
      </v-avatar>
    </template>

    <span>{{ user ? user : 'You' }}</span>

  </v-tooltip>

</template>

<script>

export default {

  // #region Properties

  props: {
    user: String
  },
  computed: {
    avatar() {
      if (!this.user) {
        return '?';
      }

      return this.user.charAt(0);
    },
    color() {
      if (!this.user) {
        return '#0099ee';
      }

      let stringUniqueHash = [...this.user].reduce((acc, char) => {
        return char.charCodeAt(0) + ((acc << 5) - acc);
      }, 0);
      return `hsl(${stringUniqueHash % 360}, 95%, 35%)`;
    }
  }

  // #endregion Properties

}

</script>
